// extracted by mini-css-extract-plugin
export default {"box":"Simulator_box__L0rsN","label":"Simulator_label__mZtW-"};